import { setLastName } from "../../domain/subscribe/subscribeModel"
import { UpdateSubscribeStore, updateSubscribeUseCase } from "./updateSubscribeUseCase"


const setLastNameUseCase = (store: UpdateSubscribeStore, value: string) => 
    updateSubscribeUseCase(store, value, setLastName);


export { setLastNameUseCase }